import { DialogBody } from './DialogBody';

// TODO: in v9, move styled() from DialogBody.jsx to here
export var StyledDialogBody = DialogBody;